import { Autocomplete, Button, TextField } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { DateRangePicker } from "react-dates";

const FilterForm = ({ rows, handleSubmit, handleReset, filters }) => {
  const [focusedInput, setFocusedInput] = useState(null);
  const [startDate, setStartDate] = useState(filters[4].value[0]);
  const [endDate, setEndDate] = useState(filters[4].value[1]);
  const [currentFilters, setCurrentFilters] = useState(filters)
  const [utilCodes, setUtilCodes] = useState([]);
  const [commodityCodes, setCommodityCodes] = useState([]);
  const [billClasses, setBillClasses] = useState([]);
  const [stateIds, setStateIds] = useState([]);

  useEffect(() => {
    setCurrentFilters(filters)
  }, [filters])

useEffect(() => {
  setStartDate(filters[4].value[0]);
  setEndDate(filters[4].value[1]);
}, [filters]);

  useEffect(() => {
    if (!rows || rows.length === 0) return
    const newUtilCodes = [
      ...new Map(
        rows
          .filter((r) =>
            filters[1].value !== ""
              ? r.state_id === filters[1].value
                ? true
                : false
              : true
          )
          .map((row) => [
            row.utility_code,
            { label: row.utility_code, value: row.utility_code },
          ])
          .sort((a, b) => (a.value > b.value ? -1 : 1))
      ).values(),
    ];
    setUtilCodes(newUtilCodes);

    const newCommodityCodes = [
      ...new Map(
        rows.map((row) => [
          row.commodity,
          { label: row.commodity, value: row.commodity },
        ])
      ).values(),
    ];
    setCommodityCodes(newCommodityCodes);

    const newBillClasses = [
      ...new Map(
        rows.map((row) => [
          row.class,
          { label: row.class, value: row.class }
        ])
      ).values()
    ];
    setBillClasses(newBillClasses);

    const newStateIds = [
      ...new Map(
        rows.map((row) => [
          row.state_id,
          { label: row.state_id, value: row.state_id },
        ])
      ).values(),
    ].sort();
    setStateIds(newStateIds);
  }, [rows, filters]);

  const handleChange = (val, name) => {
    setCurrentFilters(prevFilters => {
      return prevFilters.map(filter => {
        if (filter.name === name) {
          if (name === "date") {
            return { ...filter, value: val || ["", ""] };
          }
          return { ...filter, value: val?.value || "" };
        }
        return filter;
      });
    });
  };
  return (
    <form>
      <div className="flex flex-row px-20 py-10 sm:flex-wrap sm:px-2 sm:py-10 ">
        <div className="mx-10 sm:mb-5  sm:w-full md:w-[8rem] ">
          <Autocomplete
            disablePortal
            options={stateIds}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="State" />}
            value={currentFilters[1]["value"]}
            onChange={(e, val) => handleChange(val, "state_id")}
            className="max-w-32 sm:!w-[92%]important"
          />
        </div>
        <div className="mx-10 sm:mb-5 sm:w-full md:w-[300px]">
          <Autocomplete
            disablePortal
            options={utilCodes}
            sx={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Utility Code" />
            )}
            value={currentFilters[0]["value"]}
            onChange={(e, val) => handleChange(val, "utility_code")}
          />
        </div>
        <div className="mx-10 sm:mb-5 sm:w-full  md:w-[300px]">
          <Autocomplete
            disablePortal
            options={commodityCodes}
            sx={{ width: 300 }}
            value={currentFilters[2]["value"]}
            renderInput={(params) => (
              <TextField {...params} label="Commodity" />
            )}
            onChange={(e, val) => handleChange(val, "commodity")}
          />
        </div>

        <div className="mx-10 sm:mb-5 sm:w-full  md:w-[300px]">
          <Autocomplete
            disablePortal
            options={billClasses}
            sx={{ width: 300 }}
            value={currentFilters[3]["value"]}
            renderInput={(params) => (
              <TextField {...params} label="Bill Class" />
            )}
            onChange={(e, val) => handleChange(val, "class")}
          />
        </div>

        <div className="mx-10 sm:mb-5 sm:w-full  md:w-[300px]">
          <DateRangePicker
            startDate={startDate}
            startDateId="start_date"
            endDate={endDate}
            endDateId="end_date"
            onDatesChange={({ startDate, endDate }) => {
              setStartDate(startDate);
              setEndDate(endDate)
              const _date = [startDate, endDate];
              handleChange(_date, "date")

            }}
            focusedInput={focusedInput}
            onFocusChange={(focusedInput) => {
              setFocusedInput(focusedInput)
            }}
            isOutsideRange={(day) => day.isAfter(moment(), "day")}
            minimumNights={0}
          />
        </div>

      </div>

      <div className="flex px-10 py-10 justify-end  sm:px-5 sm:pt-2">
        <Button
          className="mx-5 !important"
          variant="outlined"
          onClick={() => {
            handleReset();
          }}
        >
          Reset
        </Button>
        <Button
          className="!mx-5"
          variant="contained"
          onClick={() => {
            let filtersToSubmit = currentFilters;
            if (startDate && !endDate) {
              const today = moment();
              setEndDate(today);
              filtersToSubmit = currentFilters.map(filter => 
                filter.name === "date" 
                  ? { ...filter, value: [startDate, today] }
                  : filter
              );
            }
            handleSubmit(filtersToSubmit);
          }}
        >
          Submit
        </Button>
      </div>
    </form>
  );
};

export default FilterForm;
